var ChannelMembersView = require('channelmembersview');
var ChannelStatusView = require('channelstatusview');
var ChildView = require('childview');


var ChannelView = ChildView.extend({
    className: ChildView.prototype.className + ' channel',
    initialize: function (options) {
        this.status = new ChannelStatusView(options);
        this.members = new ChannelMembersView(options);
        this.model.bind('prefChange:hiddenMembers', this.renderMemberShown, this);
        this.model.bind('twitchChannelChange', this.renderMemberShown, this);
        
        ChildView.prototype.initialize.apply(this, arguments);
    },
    renderActive: function () {
        this.renderMemberShown();
        this.renderMemberCount();
        ChildView.prototype.renderActive.apply(this, arguments);
    },
    shouldShowMemberList: function () {
        return !this.model.getTwitchInfo() && this.model.isActive() && this.model.shouldShowMemberList();
    },
    renderMemberShown: function () {
        if (this.model.isSelected()) {
            this.scroll.onAnimate(250, _.bind(function renderMemberShownTick (pinBottom) {
                this.scrollWidthChange(pinBottom);
            }, this), _.bind(function renderMemberShownAfter () {
                if (this.shouldShowMemberList()) {
                    this.$el.addClass('membersShown');
                }
            }, this));
        }
        this.$('div.memberwrapper').attr('aria-hidden', String(!this.shouldShowMemberList()));
        this.$('.memberToggle').attr('aria-expanded', String(this.shouldShowMemberList()));
        if (this.shouldShowMemberList()) {
            this.$el.addClass('showMembers');
            if (!this.model.isSelected()) {
                this.$el.addClass('membersShown');
            }
        } else {
            this.$el.removeClass('showMembers');
            this.$el.removeClass('membersShown');
        }
    },
    renderMemberCount: function () {
        if (this.model.isActive()) {
            this.status.renderMemberCount();
            this.mainTopChange();
        }
    },
    hoverUserRows: function (user) {
        ChildView.prototype.hoverUserRows.apply(this, arguments);
        var attr = '[data-usermask="' + this.formatter.escapeQuerySelector(user.getHostMask()) + '"]';
        var attr2 = '[data-name="' + this.formatter.escapeQuerySelector(user.getName()) + '"]';
        this.members.$('li.user' + attr + ', li.user' + attr2).addClass('hover');
    },
    unhoverUserRows: function () {
        ChildView.prototype.unhoverUserRows.apply(this, arguments);
        this.members.$('li.user').removeClass('hover');
    },
    postrender: function () {
        this.$('div.memberwrapper').append(this.members.render().el);
        this.renderMemberShown();
    },
    render: function () {
        ChildView.prototype.render.apply(this, arguments);
        
        this.$el.toggleClass('slack_mpdm', this.model.isSlackMultiPersonDm());

        this.renderMode();
        this.model.bind('modeChange', this.renderMode, this);
        this.model.userMember.bind('change:mode', this.renderUserMember, this);
        
        this.model.members.bind('add remove reset', this.renderMemberCount, this);
        
        return this;
    },
    renderUserMember: function () {
        if (this.buffer.userMember.hasChanged()) {
            this.$el.removeClass(this.buffer.userMember.getPreviousModeClass());
        }
        this.$el.addClass(this.buffer.userMember.getModeClass());
        this.$el.toggleClass('mod', this.buffer.userMember.isMod());
    },
    renderMode: function () {
        this.$el.toggleClass('secret', this.buffer.hasMode('s'));
        this.$el.toggleClass('private', this.buffer.hasMode('p'));
        this.$el.toggleClass('moderated', this.buffer.hasMode('m'));
        this.$el.toggleClass('inviteOnly', this.buffer.hasMode('i'));
        this.$el.toggleClass('password', this.buffer.isPassworded());
        this.$el.toggleClass('topicControl', this.buffer.hasMode('t'));
        this.$el.toggleClass('noExternal', this.buffer.hasMode('n'));
        this.$el.toggleClass('limited', this.buffer.hasMode('l'));
        
        // Update classnames for the user member if we have one yet
        this.renderUserMember();
    }
});


module.exports = ChannelView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/channelview.js
// module id = OzoI
// module chunks = 1